import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Import utilities
import { useOperators } from 'components/utilities';

// Import styles
import { flex, media } from 'components/styles';

// Import components
import ProductPackets from './ProductPackets';

const Packets = ({ playerType, message }) => {
	const { t } = useTranslation();

	const { isRetailOrGuest, isOperator, operator } = useOperators();

	return (
		<Wrapper>
			{isOperator && (
				<Paragraph>
					{t(`opertators_player_resources_not_in_products_${operator}`)}
				</Paragraph>
			)}

			{isRetailOrGuest && (
				<ProductPackets playerType={playerType} message={message} />
			)}
		</Wrapper>
	);
};

Packets.propTypes = {
	playerType: PropTypes.string,
	message: PropTypes.string
};

const Wrapper = styled.div`
	width: 90%;
	${flex()};
	flex-direction: column;
	margin: 0 auto;
	${media.min.xmin(css`
		margin: 3.7rem auto;
		width: 61rem;
	`)}
`;

const Paragraph = styled.p`
	text-align: center;
	letter-spacing: 0.63px;
	font-size: 2.5rem;
	font-weight: ${({ theme }) => theme.font.light};
	color: ${({ theme }) => theme.white};
	opacity: 0.4;
`;

export default Packets;
